//natives
import React, {Component} from 'react';
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet';
import TagManager from 'react-gtm-module';
import base64 from 'base-64';

//components
import Section from '../childrens/section/.mixins/index';
import ModalEndereco from '../../endereco/.mixins/index';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Pedidos_controller from '../../../../../../controllers/pedido';
import { getRetiradasPendentes } from '../../../../../../controllers/retiradaspendentes';
import Log from '../../../../../../controllers/log';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import compliance from 'controllers/compliance';

export default class Home extends Component {
  static contextType  = AuthContext;

  constructor(props) {
      super(props);

      this.child = React.createRef();
      this.documentNotification = React.createRef();
      this.pendingReturnProductsNotification = React.createRef();
      this.permissions = {};

      this.state = {
          isLoading: true,
          openEndereco: false
      }
      this.handleDialogEndereco = this.handleDialogEndereco.bind(this)
  }

  handleDialogEndereco(){
    this.setState({openEndereco: !this.state.openEndereco});
  };

  componentWillMount() {
    this.permissions = this.context.user.permissions;
    this.role = this.context.user.role;
  }

  componentDidMount() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    if (window.alertPedido) {
      this.verificaPedidos();
      window.alertPedido = false;
    }

    this.gaLoad(cookies);

    const hasRolePermission =  this.role === 'Master' || this.role === 'Admin - Comercial' || this.role === 'Admin - sourcing'

    if (
        this.permissions["user-compliance"] &&
        !this.permissions["admin-compliance"] &&
        !hasRolePermission
      ) {
      this.hasDocPending(token, cookies.get('User-Code'));
    }

    if(!this.context.user.isVisaoTok && this.permissions["gerenciar-pedidos.retiradas-pendentes"])
      this.hasPendingReturnProducts();

    //auditoria
    Log.info(token,"Efetuado carregamento da tela Home!");
  }

  gaLoad(cookies) {
    const ga_informations = cookies.get('ga_informations');

    // TagManager.dataLayer({
    //   dataLayer: {
    //     event: 'event',
    //     eventCategory: 'tokstok:fornecedores:inicio',
    //     eventAction: 'componentDidMount',
    //     eventLabel: 'componente-home',
    //   }
    // });

    if (ga_informations) {
      TagManager.dataLayer({dataLayer: JSON.parse(base64.decode(ga_informations))});
    }
  };

  verificaPedidos = async () => {

      //declara cookie para utilizar o token
      const cookies = new Cookies();
      const token = cookies.get('User-Token');

      try {

          //faz requisicao para verificar qtd de pedidos
          var r_pedidos = await Pedidos_controller.getPendentes(token);

          //converte retorno em json para poder trabalhar com valores
          var r_j_pedidos = JSON.parse(r_pedidos.body);

          //checa se ha pedidos
          if (r_j_pedidos.status && r_j_pedidos.itens.length > 0 && r_pedidos.res.statusCode == 200)
            this.child.current.retornoWithoutAutoClose('Você tem pedidos pendentes. Acesse a página de Pedidos não agendados!','warning');

          // TagManager.dataLayer({
          //   dataLayer: {
          //     event: 'event',
          //     eventCategory: 'tokstok:fornecedores:inicio',
          //     eventAction: 'callback',
          //     eventLabel: 'sucesso',
          //   }
          // });

          //auditoria
          var str = "Efetuada requisição para verificação do retorno de pedidos! "
            +"Response:( Method: "+r_pedidos.res.request.method
            +", StatusCode: "+r_pedidos.res.statusCode
            +", Body: (limited 100chars)"+r_pedidos.body.substr(0,100)
            +" )";
          Log.info(token,str);

      } catch (error) {

        // TagManager.dataLayer({
        //   dataLayer: {
        //     event: 'event',
        //     eventCategory: 'tokstok:fornecedores:inicio',
        //     eventAction: 'callback',
        //     eventLabel: `erro:${error.message}`,
        //   }
        // });

        //auditoria
        var str = "Erro na recuperação de dados de pedidos! "
        +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
        Log.error(token,str);
      }

  }

  hasDocPending = async (token, id) => {
    const body = await compliance.qtyDocumentsPending(token, id);
    const quantity = JSON.parse(body.body).quantity;
    if ( quantity > 0) {
      this.documentNotification.current.retornoWithoutAutoClose('Você possui alguns documentos pendentes de aceite!','warning');
    }
  }

  hasPendingReturnProducts = async () => {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const personId = cookies.get('User-Code');
    const retiradasPendentes = await getRetiradasPendentes(token, { personId });
    const responseJSON = JSON.parse(retiradasPendentes.body);
    const totalRetiradasPendentes = responseJSON[0]?.totalRows ? responseJSON[0]?.totalRows : 0;
    if ( totalRetiradasPendentes > 0) {
      this.pendingReturnProductsNotification.current.retornoWithoutAutoClose('Você possui algumas retiradas pendentes! Consulte a página de gerenciar pedidos!','warning');
    }
  }

  render() {
    return(
        <div>
          <Helmet>
            <title>{`${process.env.REACT_APP_TITLE} - Home`}</title>
          </Helmet>
          <Alerta ref={this.child}/>
          <Alerta ref={this.documentNotification}/>
          <Alerta ref={this.pendingReturnProductsNotification} />
          <Section {...this}/>
          <ModalEndereco {...this}/>
        </div>
    );
  }

}
